import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

export type ConstructionTimelinePhaseDto = {
  id: number;
  title: string;
  approxDays: number;
  sortOrder: number;
  createdAt: string;
};

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

export async function fetchConstructionTimelinePhases(): Promise<ConstructionTimelinePhaseDto[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/construction-timeline/phases`);
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<ConstructionTimelinePhaseDto[]>;
}

export async function createConstructionTimelinePhase(input: {
  title: string;
  approxDays: number;
}): Promise<ConstructionTimelinePhaseDto> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/construction-timeline/phases`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<ConstructionTimelinePhaseDto>;
}

export async function updateConstructionTimelinePhaseApi(
  id: string,
  patch: Partial<{ title: string; approxDays: number; sortOrder: number }>,
): Promise<ConstructionTimelinePhaseDto> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/construction-timeline/phases/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<ConstructionTimelinePhaseDto>;
}

export async function deleteConstructionTimelinePhaseApi(id: string): Promise<void> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/construction-timeline/phases/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (!res.ok && res.status !== 204) throw new Error(await parseError(res));
}

export async function reorderConstructionTimelinePhases(orderedIds: number[]): Promise<ConstructionTimelinePhaseDto[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/construction-timeline/phases/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderedIds }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<ConstructionTimelinePhaseDto[]>;
}
